<template>
    <form @submit.prevent="submit">

        <remote-select class="mb-4"
            :label="$t('common.cohort')"
            v-model="localFilters.cohort_id"
            :searchMethod="searchCohort"
            :findMethod="findCohort"
        >
        </remote-select>

        <remote-select class="mb-4"
            :label="$t('common.degree')"
            v-model="localFilters.degree_id"
            :searchMethod="searchDegree"
            :findMethod="findDegree"
        >
        </remote-select>

        <div class="text-center">
            <base-button native-type="submit" type="primary">
                {{ $t('common.apply') }}
            </base-button>

            <base-button type="link" @click="modal.show = false">
                {{ $t('common.cancel') }}
            </base-button>
        </div>

    </form>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
        },

        data() {
            return {
                localFilters: {}
            }
        },

        watch: {
            value: {
                handler(newValue) {
                    this.localFilters = {...newValue}
                },
                immediate: true
            }
        },

        methods: {

            searchCohort(value) {
                return axios.get('/socrates/api/front/cohorts', {params: {
                    filters: { name: { $text: value } },
                    sort: ['name'],
                }})
            },

            searchDegree(value) {
                return axios.get('/socrates/api/front/degrees', {params: {
                    filters: { simpleSearch: value },
                    sort: ['name'],
                }})
            },

            findCohort(id) {
                return axios.get('/socrates/api/front/cohorts/' + id)
            },

            findDegree(id) {
                return axios.get('/socrates/api/front/degrees/' + id)
            },

            submit() {
                this.$emit('input', {
                    cohort_id: this.localFilters.cohort_id,
                    degree_id: this.localFilters.degree_id,
                })
                this.modal.show = false
            },
        }
    }
</script>
